import React from 'react';
import PropTypes from 'prop-types';

// styles
import styles from './styles/Subtitle.scss';

export const Subtitle = props => {
    const { subtitle, subtitleUrl, trackTileClick } = props;
    if (!subtitle) {
        return null;
    }

    if (!subtitleUrl) {
        return <div className={styles.subtitle}>{subtitle}</div>;
    }

    return (
        <div className={styles.subtitle}>
            <a
                className={styles.subtitleLink}
                href={subtitleUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={trackTileClick}
            >
                {subtitle}
            </a>
        </div>
    );
};

Subtitle.propTypes = {
    subtitle: PropTypes.string,
    subtitleUrl: PropTypes.string,
    trackTileClick: PropTypes.func.isRequired,
};
